// @flow
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { CSSTransitionGroup } from 'react-transition-group';
import Input from '../../components/Input';
import { FirstChild } from '../../helpers';
import { noValidate } from '../../helpers';

type Props = {
  isSaving: boolean,
  settings: Object,
  successMsg: string,
  errorMsg: string,
  handleSubmit: (v: Object) => void
};

type State = {};

class SettingsAMBookingForm extends React.Component<Props, State> {
  setThreeDecimalPoints = (e: SyntheticKeyboardEvent<*>) => {
    const val = e.currentTarget.value;
    const text = val.toString();
    const index = text.indexOf('.');
    if (text.length - index - 1 > 3) {
      e.currentTarget.value = e.currentTarget.value.substring(0, index + 4);
    }
  };

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit}>
        <Row>
          <Col sm={4}>
            <Field
              component={Input}
              type="number"
              min="0"
              step=".001"
              label="AM Indicative Pricing"
              placeholder={
                this.props.settings && this.props.settings.indicativeAmRate
                  ? this.props.settings.indicativeAmRate.description
                  : ''
              }
              name="indicativeAmRate.value"
              validate={[noValidate]}
              onKeyUp={this.setThreeDecimalPoints}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={4}>
            <Field
              component={Input}
              type="text"
              label="AM Product Terms and Conditions"
              placeholder={
                this.props.settings &&
                this.props.settings.amProductTermsAndConditions
                  ? this.props.settings.amProductTermsAndConditions.description
                  : ''
              }
              name="amProductTermsAndConditions.value"
              validate={[noValidate]}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Field
              component={Input}
              type="text"
              label="AM Product Guide URL"
              placeholder={
                this.props.settings && this.props.settings.amProductGuide
                  ? this.props.settings.amProductGuide.description
                  : ''
              }
              name="amProductGuide.value"
              validate={[noValidate]}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Field
              component={Input}
              type="number"
              min="0"
              label="Addressed Record Download Limit"
              placeholder={
                this.props.settings &&
                this.props.settings.amAddressRecordDownloadLimit
                  ? this.props.settings.amAddressRecordDownloadLimit.description
                  : ''
              }
              name="amAddressRecordDownloadLimit.value"
              validate={[noValidate]}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Field
              component={Input}
              type="number"
              min="0"
              label="Download Limit Time Period (days)"
              placeholder={
                this.props.settings &&
                this.props.settings.amDownloadLimitTimePeriod
                  ? this.props.settings.amDownloadLimitTimePeriod.description
                  : ''
              }
              name="amDownloadLimitTimePeriod.value"
              validate={[noValidate]}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Button
              bsStyle="primary"
              type="submit"
              className="relative-padding"
              disabled={this.props.isSaving}
            >
              {this.props.isSaving ? 'Saving...' : 'Save'}
            </Button>
          </Col>
        </Row>
        <br />
        <Row>
          <Col sm={12}>
            <CSSTransitionGroup
              component={FirstChild}
              transitionName="fade"
              transitionEnterTimeout={300}
              transitionLeaveTimeout={300}
            >
              {this.props.successMsg ? (
                <p key="success" className="text-success">
                  {this.props.successMsg}
                </p>
              ) : null}
            </CSSTransitionGroup>
          </Col>
        </Row>
        {this.props.errorMsg && (
          <div className="alert alert-danger">{this.props.errorMsg}</div>
        )}
      </Form>
    );
  }
}
// const SettingsAMBookingForm = ({
//   handleSubmit,
//   settings,
//   isSaving,
//   successMsg,
//   errorMsg,
//   ...this.props
// }: Props) => (

// );

export default reduxForm({
  form: 'settingsAMBookingForm'
})(SettingsAMBookingForm);

/*
- AM Default price
- AM Min Lodgement Quantity
- AM Max Lodgement Quantity
- Min Lodgement Percentage
- AM Help Links
- AM Specific T&C's Link
- Set AM Booking Lodgement Email Text
- Set AM Lodgement Due Period
*/



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsAMBookingForm.js